import script from "./AreaSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./AreaSetting.vue?vue&type=script&setup=true&lang=js"

import "./AreaSetting.vue?vue&type=style&index=0&id=e924b28e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e924b28e"]])

export default __exports__